'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _BaseList = require('../common/BaseList');

var _BaseList2 = _interopRequireDefault(_BaseList);

var _AddLoanAccountModal = require('../page-loan-account/AddLoanAccountModal');

var _AddLoanAccountModal2 = _interopRequireDefault(_AddLoanAccountModal);

var _SmartBool = require('../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _constants = require('../../constants');

var _common = require('../common');

var _utils = require('../../utils');

var _util = require('../../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

// Loan account types and statuses come back from the API as raw enum values, so their columns
// render the label from the option list served by /options/ rather than the value.
var renderDate = _utils.TableRenderingUtils.renderDate,
    renderOptionLabel = _utils.TableRenderingUtils.renderOptionLabel,
    renderUnformatted = _utils.TableRenderingUtils.renderUnformatted,
    LENDING_PAGE_SIZE = _constants.AppConstants.LENDING_PAGE_SIZE,
    LOAN_ACCOUNT_MAIN_TABS = _constants.AppConstants.LOAN_ACCOUNT_MAIN_TABS,
    PERMISSIONS = _constants.AppConstants.PERMISSIONS,
    ROUTING = _constants.AppConstants.ROUTING,
    USER_FLOW = _constants.AppConstants.USER_FLOW;
var LendingList = (_dec = (0, _mobxReact.inject)('Clients', 'OptionsStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(LendingList, _Component);

  function LendingList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LendingList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LendingList.__proto__ || Object.getPrototypeOf(LendingList)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'currentPageNumber', _descriptor, _this), _initDefineProp(_this, 'showAddModal', _descriptor2, _this), _this.searchString = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LendingList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var searchString = this.props.searchString;

      // Record what we are about to load before loading it. Without this the guard below compares
      // against null forever, so every parent re-render re-fetches the page we already have.

      this.searchString = searchString;

      // The page pushes its filters onto the URL on mount; we fetch when they arrive as new props.
      if (searchString === 'INITIAL') {
        return;
      }

      this.fetchTableData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.searchString !== nextProps.searchString) {
        this.searchString = nextProps.searchString;
        this.fetchTableData();
      }
    }
  }, {
    key: 'rowLocation',
    value: function rowLocation(state, rowInfo) {
      var id = (0, _get3.default)(rowInfo, 'original.id');

      if (!id) {
        return null;
      }

      return {
        pathname: ROUTING.loanAccounts + '/' + id + '/' + LOAN_ACCOUNT_MAIN_TABS.DETAILS,
        state: USER_FLOW.FROM_LENDING_PAGE
      };
    }
  }, {
    key: 'handlePagination',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(page) {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = _urijs2.default.parse(page).query;


                this.currentPageNumber = (0, _util.setPagination)(query);
                _context.next = 4;
                return this.fetchTableData(true);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handlePagination(_x) {
        return _ref2.apply(this, arguments);
      }

      return handlePagination;
    }()
  }, {
    key: 'fetchTableData',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var paginating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _props, Clients, lendingPage, params, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props = this.props, Clients = _props.Clients, lendingPage = _props.UiStore.lendingPage;


                lendingPage.loading = true;

                if (!paginating) {
                  this.currentPageNumber = '1';
                }

                _context2.prev = 3;
                params = _extends({}, lendingPage.query, { page: this.currentPageNumber, page_size: LENDING_PAGE_SIZE });
                _context2.next = 7;
                return Clients.loanAccounts.list({ params: params });

              case 7:
                data = _context2.sent;


                lendingPage.total = data.count;
                lendingPage.tableData = data.results;
                lendingPage.nextPageURL = data.next;
                lendingPage.previousPageURL = data.previous;
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](3);

                // Transport has already toasted the failure. Swallowing it here avoids a second toast, and
                // avoids an unhandled rejection when this runs from an event handler.
                // eslint-disable-next-line no-console
                console.error('Error fetching the lending list:', _context2.t0);

              case 17:
                _context2.prev = 17;

                lendingPage.loading = false;
                return _context2.finish(17);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 14, 17, 20]]);
      }));

      function fetchTableData() {
        return _ref3.apply(this, arguments);
      }

      return fetchTableData;
    }()
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var SessionStore = this.props.SessionStore;


      return _react2.default.createElement(
        'header',
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Lending'
        ),
        SessionStore.userHasPermission(PERMISSIONS.ADD_LOAN_ACCOUNT) && _react2.default.createElement(
          _Button2.default,
          { className: 'btn-add', bsStyle: 'primary', onClick: this.showAddModal.setTrue },
          _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
          ' Add new account'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var UiStore = this.props.UiStore;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_BaseList2.default, {
          columns: this.tableColumns,
          currentPageNumber: this.currentPageNumber,
          entityType: 'accounts',
          handlePagination: this.handlePagination,
          handleSort: this.fetchTableData,
          pageSize: LENDING_PAGE_SIZE,
          pageStore: UiStore.lendingPage,
          paginated: true,
          renderHeader: this.renderHeader,
          rowLocation: this.rowLocation
        }),
        this.showAddModal.isTrue && _react2.default.createElement(_AddLoanAccountModal2.default, { onClose: this.showAddModal.setFalse })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'tableColumns',
    get: function get() {
      var OptionsStore = this.props.OptionsStore;


      return [{
        accessor: 'name',
        Cell: renderUnformatted,
        Header: 'Account Name',
        minWidth: 200
      }, {
        accessor: 'type',
        Cell: renderOptionLabel.bind(null, OptionsStore.loanAccountTypeOptions),
        Header: 'Type',
        maxWidth: 160
      }, {
        accessor: 'active_loan_count',
        Cell: renderUnformatted,
        Header: 'Active Loans',
        maxWidth: 150,
        minWidth: 120,
        // As the two dates below: the API sorts accounts by name, type and status alone, so offering a
        // sort here would show an arrow that does nothing.
        sortable: false
      },
      // Both are worked out by the API rather than held on the account, and both are empty until
      // there is something to show: an account with no loans has never originated one, and one that
      // owes no compliance charge has nothing falling due. renderDate gives EMPTY_FIELD for either.
      {
        accessor: 'latest_origination_date',
        Cell: renderDate,
        Header: 'Latest Origination',
        maxWidth: 200,
        minWidth: 150,
        sortable: false
      }, {
        accessor: 'next_compliance_due_date',
        Cell: renderDate,
        Header: 'Next Due',
        maxWidth: 200,
        minWidth: 130,
        sortable: false
      }, {
        accessor: 'status',
        Cell: renderOptionLabel.bind(null, OptionsStore.loanAccountStatusOptions),
        Header: 'Status',
        maxWidth: 160
      }];
    }
  }]);

  return LendingList;
}(_react.Component), _class3.propTypes = {
  Clients: _propTypes2.default.object.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  searchString: _propTypes2.default.string.isRequired,
  SessionStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'currentPageNumber', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '1';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'showAddModal', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'handlePagination', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handlePagination'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = LendingList;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(renderDate, 'renderDate', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(renderOptionLabel, 'renderOptionLabel', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(renderUnformatted, 'renderUnformatted', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(LENDING_PAGE_SIZE, 'LENDING_PAGE_SIZE', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(LOAN_ACCOUNT_MAIN_TABS, 'LOAN_ACCOUNT_MAIN_TABS', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(PERMISSIONS, 'PERMISSIONS', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(ROUTING, 'ROUTING', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(LendingList, 'LendingList', '/app/src/components/page-lending/LendingList.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-lending/LendingList.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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